export default {
    blue: '#8dd7f7',
    darkBlue: '#297cc0',
    purple: '#2c2b7b',
    white: '#fff',
    black: '#000'
}


// WEBPACK FOOTER //
// ./src/pages/reportCards/colors.js